
import { defineComponent } from 'vue'
import Slideshow from './header/Slideshow.vue'
import StartMorphingText from './StartMorphingText.vue'
import { subpages } from '@/data/navigation/subpages'
import { langs } from '@/data/navigation/langs'

interface Subpage {
  text: string
  link?: string
  links?: {
    en: string
    jp: string
    kr: string
  }
  scrollTo?: string
}

export default defineComponent({
  data(): { subpages: Subpage[]; langs: typeof langs; previewImage: string } {
    return {
      subpages,
      langs,
      previewImage: '',
    }
  },
  components: {
    Slideshow,
    StartMorphingText,
  },
  computed: {
    currentLanguage(): string {
      return this.$store.getters.getAppLanguage
    },
    getAppStoreLink(): string {
      const appStoreSubpage = this.subpages.find(
        (subpage) => subpage.text === 'appStore'
      )
      if (appStoreSubpage) {
        return this.getLinkForCurrentLanguage(appStoreSubpage)
      }
      return '#'
    },
    getGoogleplayLink(): string {
      const appStoreSubpage = this.subpages.find(
        (subpage) => subpage.text === 'googlePlay'
      )
      if (appStoreSubpage) {
        return this.getLinkForCurrentLanguage(appStoreSubpage)
      }
      return '#'
    },
  },
  methods: {
    isLanguageKey(key: string): key is 'en' | 'jp' | 'kr' {
      return ['en', 'jp', 'kr'].includes(key)
    },
    getLinkForCurrentLanguage(subpage: Subpage) {
      if (subpage.links && this.isLanguageKey(this.currentLanguage)) {
        return subpage.links[this.currentLanguage]
      }
      return '#'
    },
    updatePreviewImage(lang: string) {
      const assetLang = lang === 'jp' ? 'ja' : lang
      if (this.isLanguageKey(lang)) {
        this.previewImage = require(`@/assets/pages/home/screens/home-preview-${assetLang}.png`)
        return
      }
      this.previewImage = require('@/assets/pages/home/screens/home-preview-en.png')
    },
  },
  watch: {
    currentLanguage(newLang) {
      this.updatePreviewImage(newLang)
    },
  },
  created() {
    this.updatePreviewImage(this.currentLanguage)
  },
})
